import angular from 'angular';

window.angular = angular;

import 'jquery';
import 'popper.js';
import 'bootstrap';

import './styles/deeplink.scss';

import './app.module';

import './components/deeplink/deeplink.component';

angular.element(document).ready(() => {
  angular.bootstrap(document, ['Toke']);
});